import { styled } from '@mui/material';

export const StyledWrapperStepContent = styled('div')`
  display: flex;
  flex-direction: column;
  gap: 16px;
  max-width: 960px;
  height: 360px;
  gap: 24px;
  border-radius: 16px;
  padding: 24px 24px 24px 24px;
  background-color: #f4f5f7a3;
  box-sizing: border-box;
`;
